import { render, staticRenderFns } from "./forward_grouping.vue?vue&type=template&id=319df1f8&scoped=true&"
import script from "./forward_grouping.vue?vue&type=script&lang=js&"
export * from "./forward_grouping.vue?vue&type=script&lang=js&"
import style0 from "./forward_grouping.vue?vue&type=style&index=0&id=319df1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319df1f8",
  null
  
)

export default component.exports